import styled from 'styled-components';

export const Bubble = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: calc(100% / 3 - 20px);
  margin: 10px;
  position: relative;
  text-align: center;

  .bubble_icon {
    position: absolute;
    left: calc(50% + 2rem);
    top: 6.4rem;
  }

  @media (min-width: 800px) {
    width: 100px;
  }
`;

export const Image = styled.div`
  width: 90px;
  height: 90px;
  max-width: 90px;
  max-height: 90px;
  line-height: 70px;
  border-radius: 50%;
  background-color: #fff;
  background-image: ${props => (props.background ? `url(${props.background})` : 'none')};
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  margin: 0px auto 10px;
  font-size: 32px;
  text-align: center;
  box-shadow: ${props => (props.selected ? '0px 0px 0px 6px rgba(255,255,255,0.6)' : 'none')};
  transform: scale(${props => (props.selected ? 1 : 0.8)});
  opacity: ${props => (props.selected ? 1 : 0.75)};
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.div`
  color: ${props => (props.colorText ? props.colorText : '#fff')};
  font-size: 12px;
  height: 26px;
  overflow: hidden;
  text-align: center;
  margin-bottom: 2rem;
  margin-top: 1rem;
  line-height: 1.3rem;
`;


export const FacesWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: ${props => (props.isDragging ? 'hidden' : 'auto')};
  position: relative;
  text-align: center;
`;

export const BubblesWrapper = styled.div`
  max-height: 100%;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  position: relative;
  display: flex;
`;

export const DetailDeliverable = styled.div`
  position: relative;
  width: 100%;
  border-radius: 4px;
  background-color: ${props => props.color};
  z-index: 10;
`;

export const CloseDetail = styled.i`
  position: absolute;
  top: 5px;
  right: 5px;
  color: #4d4d4d;
  font-size: 14px;
  cursor: pointer;
`;

export const Card = styled.div`
  position: relative;
  margin: 0 auto 0px;
  border-left: 0;
  border-right: 0;

  svg {
    background-color: transparent !important;
  }
`;

export const FeedbackLayer = styled.div`
  height: 80vh;
`;



// WEBPACK FOOTER //
// ./src/components/Steps/Faces/components/styles.js